import { IgenomicsAction } from "@ispm/core/interfaces/genomics-action.interface";
import { ILogiDashboardsDetails } from "../../interfaces/analytics-configuration.interface";

export const SetLogiDashboardDetails = 'Analytics.SetLogiDashboardsDetails';
export function setSetLogiDashboardsDetails(dashboards: ILogiDashboardsDetails): IgenomicsAction<ILogiDashboardsDetails> {
  return {
    type: SetLogiDashboardDetails,
    payload: dashboards
  };
}

